module.exports = __webpack_public_path__ + "img/company_logo.ba7e3bc0.png";